import React, { useEffect, useState } from 'react'
import "./TotalSidebar.css"
import {  Link, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { SnackbarProvider, useSnackbar } from "notistack"
import { useSelector } from 'react-redux';
import country from '../../country.json';
import AlertContainer from '../Alert/Alert';
import { Spinner } from 'react-bootstrap';

function TotalSidebar({ item, payment, phone,orderData }) {
    const { currentLocal } = useSelector((state) => state.currentLocal);
    console.log(item,"item");
    
  const location = useLocation();
  const [address, setAddress] = useState([])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const navigate = useNavigate()

  const userinfo = useSelector((state) => state);
  const shippingPrice = address[0] && country.find((item) => item.city === address[0].city);
console.log(location.pathname.substring(1));

  useEffect(() => {
    const getAllApis = async () => {
      // await axios
      //   .get(`https://nanosoft.technology/outlaw/api/client/addresses`,

      //     {
      //       headers: {
      //                       Authorization: `Bearer ${userinfo?.auth?.access_token}`
      //       }
      //     })

      //   .then(async (res) => {
      //     const filteredArray = res.data.data.filter(item => item.default==0);

      //     setAddress(filteredArray)

      //   })
      //   .catch((error) => {
      //     // setShow(true)

      //     setAddress(error.response.data);


      //   });
    }
    getAllApis()
  }, [])



  const handlecheckout = async (e) => {
    e.preventDefault();
    if (location.pathname.substring(1) == 'checkout') {
      if(!orderData?.client_street||!orderData?.client_block||!orderData?.client_city||!orderData?.client_house_number||!orderData?.client_region){
        alert('Please enter your address')
      }else{
setLoading(true)
      await axios
        .post(`https://nanosoft.technology/outlaw/api/orders`,orderData  ,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })
        .then(async (res) => {
setShow(true)
setSeverity("success")
setMsg(currentLocal.home.createorder)
setLoading(false)
setTimeout(() => {
  setShow(false)
  navigate("/")
}, 2000);
                  // setAlert("add successfully")

//   toast.success(currentLocal.home.ordersuccessMessage, {
//     position: "bottom-right",
//     autoClose: 3000,
//     rtl: currentLocal.language === "العربيه",
//   });
// setTimeout(() => {
//           navigate("/");

// }, 3500);

        })
        .catch((error) => {

setLoading(false)


        });

      }


    } else {
        navigate('/checkout')



  }
  }
  return (
    <div className='totalSidebar_container'>
        {show &&
        <AlertContainer
          msg={msg}
          severity={severity}
        />

      }
      <div>
        <SnackbarProvider />
      </div>
      <div className='d-flex justify-content-between mb-3'>
        <span className='cart_title'>{currentLocal?.home?.Subtotal}
        </span>
        <span className="cart_value">EGP {item && Number(item?.summary?.subtotal_egp).toFixed(2)}</span>
      </div>
      <div className='d-flex justify-content-between mb-3'>
        <span className='cart_title'>{currentLocal.home.discount}
        </span>
        <span className="cart_value">EGP {item && Number(item?.summary?.subtotal_egp-item?.summary?.discounted_subtotal_egp).toFixed(2)}</span>
      </div>
      <div className='d-flex justify-content-between mb-3'>
        <span className='cart_title'>{currentLocal.home.priceAfterDisc}
        </span>
        <span className="cart_value">EGP {item && Number(item?.summary?.discounted_subtotal_egp).toFixed(2)}</span>
      </div>

      <div className='d-flex justify-content-between mb-3'>
        <span className='cart_title'>{currentLocal.home.shipping}
        </span>
                <span className="cart_value">EGP {item && Number(item && item?.summary?.delivery_fee_egp).toFixed(2)}</span>

      </div>
      {/* <Link to="/user/addressbook">ChooseAddress</Link> */}

      {location.pathname.substring(1) === 'cart' ?
        <></>

        :
        <></>

      }
      <div className='d-flex justify-content-between mb-3 border-top pt-3'>
        <span className='cart_title'>{currentLocal.home.total}
        </span>
                <span className="cart_value">EGP {item && Number(item?.summary?.total_price_egp).toFixed(2)}</span>
      </div>
      <div className='w-100 d-flex justify-content-center '>
    
        <button className='btn_checkout'
        style={{
          backgroundColor:loading?"gray":"#000"
        }}
        onClick={handlecheckout}>
{
  loading&&
      <Spinner animation="border" role="status" className='mx-3' size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
}
          {location.pathname.substring(1) == 'checkout'?"Buy":"Complete purchase"}

        </button>
      </div>
    </div>
  )
}

export default TotalSidebar